import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";
import { FormCheckboxGroup } from "../../common/FormCheckboxGroup";
import { FormTextarea } from "../../common/FormTextarea";
import { PersonalisedLearningSupportPlanData } from "src/models/form-types";

interface PurposeSectionProps {
  formData: PersonalisedLearningSupportPlanData;
  onTextChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onCheckboxChange: (
    name: string,
    checked: boolean,
    category: keyof PersonalisedLearningSupportPlanData
  ) => void;
  className?: string;
}

// Define the purpose options
const purposeOptions = [
  {
    id: "purpose-diagnosis",
    name: "Student with a confirmed diagnosis and functional impact",
    label: "Student with a confirmed diagnosis and functional impact",
  },
  {
    id: "purpose-oohc",
    name: "Student is in Out of Home Care (OoHC)",
    label: "Student is in Out of Home Care (OoHC)",
  },
  {
    id: "purpose-social",
    name: "Student is experiencing significant social/emotional difficulties",
    label: "Student is experiencing significant social/emotional difficulties",
  },
  {
    id: "purpose-ifs",
    name: "Student receives Integration Funding Support (IFS)",
    label: "Student receives Integration Funding Support (IFS)",
  },
  {
    id: "purpose-academic",
    name: "Student is experiencing significant academic difficulties",
    label: "Student is experiencing significant academic difficulties",
  },
];

export const PurposeSection: React.FC<PurposeSectionProps> = ({
  formData,
  onTextChange,
  onCheckboxChange,
  className,
}) => {
  // Handle checkbox changes
  const handlePurposeChange = (name: string, checked: boolean) => {
    onCheckboxChange(name, checked, "purpose");
  };

  return (
    <CollapsibleFormSection title="Purpose" className={className}>
      <p className="form-description">
        Select the reasons for creating this Personalised Learning and Support
        Plan:
      </p>

      <FormCheckboxGroup
        options={purposeOptions}
        selectedValues={formData.purpose}
        onChange={handlePurposeChange}
        columns={2}
      />

      <FormTextarea
        id="otherPurpose"
        name="otherPurpose"
        label="Other:"
        value={formData.otherPurpose}
        onChange={onTextChange}
        rows={2}
      />
    </CollapsibleFormSection>
  );
};
